import { render, staticRenderFns } from "./SimpleOperationsList.vue?vue&type=template&id=b4120c82&scoped=true&"
import script from "./SimpleOperationsList.vue?vue&type=script&lang=js&"
export * from "./SimpleOperationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4120c82",
  null
  
)

export default component.exports